import React from 'react';
import TermsAndConditionsContainer from 'features/TermsAndConditions';

const TermsAndConditionsPage = () => <TermsAndConditionsContainer />;

export default TermsAndConditionsPage;
